export class TimeCountManager {
  private _restMs: number = 0;
  private _dispose: () => void = () => {};

  constructor(private ticker: PIXI.Ticker) {}

  dispose() {
    this._dispose();
  }

  startCountDown(timeLimitMs: number) {
    this._restMs = timeLimitMs;
    const startTime = performance.now();
    const onTick = () => {
      const now = performance.now();
      this._restMs = Math.max(0, timeLimitMs - (now - startTime));
      if (this._restMs === 0) this.ticker.remove(onTick);
    };
    this.ticker.add(onTick);
    this._dispose = () => {
      this.ticker.remove(onTick);
    };
  }

  stopCountDown() {
    this._dispose();
  }

  get restMs() {
    return this._restMs;
  }
}
